import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Spin, Descriptions, message } from "antd";
import useApis from "../apis/useApis";
import appConstant from "./../json/appConstant.json";
import dayjs from "dayjs";

const SurveyDetails = () => {
  const { id } = useParams();
  const [survey, setSurvey] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { jsonApi } = useApis();

  useEffect(() => {
    const fetchSurvey = async () => {
      setLoading(true);
      setError(null);
      try {
        // const res = await jsonApi(`${appConstant.singleSurvey}?id=${id}`);
        const res = await jsonApi(
          appConstant.singleSurvey,
          { id: id },
          null,
          "delete"
        );
       
      
        // Adjust this based on actual shape
        const surveyData = res?.data?.data || res?.data || res;
      
      
        if (surveyData) {
          setSurvey(surveyData);
        } else {
          setError("Survey not found");
        }
      } catch (err) {
        console.error("Error fetching survey:", err);
        setError("Error fetching survey details");
      }
       finally {
        setLoading(false);
      }
    };
    if (id) {
      fetchSurvey();
    }
  }, [id]);

  if (loading) {
    return <Spin size="large" style={{ display: "block", margin: "40px auto" }} />;
  }
  if (error) {
    return <Card style={{ margin: 24 }}><h2>{error}</h2></Card>;
  }
  if (!survey) {
    return null;
  }

  return (
    <div style={{ padding: 24 }}>
      <Card title="Survey Details">
        <Descriptions bordered column={1}>
          <Descriptions.Item label="House ID">{survey.houseId}</Descriptions.Item>
          <Descriptions.Item label="Name">{survey.name}</Descriptions.Item>
          <Descriptions.Item label="Guardian Name">{survey.guardian_name}</Descriptions.Item>
          <Descriptions.Item label="Phone Number">{survey.phone_no}</Descriptions.Item>
          <Descriptions.Item label="Ward">{survey.WardName}</Descriptions.Item>
          <Descriptions.Item label="Mohalla">{survey.M_MohallaMaster?.MohallaName}</Descriptions.Item>
          <Descriptions.Item label="Caste">{survey.caste}</Descriptions.Item>
          <Descriptions.Item label="Relation">{survey.relation}</Descriptions.Item>
          <Descriptions.Item label="Address">{survey.address}</Descriptions.Item>
          <Descriptions.Item label="Building Rent (in Rs.)">{survey.building_rent}</Descriptions.Item>
          <Descriptions.Item label="Construction Year">{survey.construction_year}</Descriptions.Item>
          {survey.boundary && (
            <Descriptions.Item label="Boundary">
              <div>
                <div><strong>East:</strong> {survey.boundary.East}</div>
                <div><strong>West:</strong> {survey.boundary.West}</div>
                <div><strong>North:</strong> {survey.boundary.North}</div>
                <div><strong>South:</strong> {survey.boundary.South}</div>
              </div>
            </Descriptions.Item>
          )}
          <Descriptions.Item label="House Tax (in Rs.)">{survey.house_tax}</Descriptions.Item>
          <Descriptions.Item label="Area of Building Plot (in sq.m.)">{survey.area_of_building_plot}</Descriptions.Item>
          <Descriptions.Item label="Nature of Construction">{survey?.M_NatureConstruction?.ConstructionNature}</Descriptions.Item>
          <Descriptions.Item label="Property Type">{survey.M_PropertyType?.PropertyType}</Descriptions.Item>
          <Descriptions.Item label="Property Status">{survey.M_PropertyStatus?.PStatusDetails}</Descriptions.Item>
          <Descriptions.Item label="Property Category">{survey.property_categorie?.name}</Descriptions.Item>
          <Descriptions.Item label="Property Commercial Category">{survey?.M_CommercialCategory?.CommCategoryName}</Descriptions.Item>
          <Descriptions.Item label="Property Commercial Sub Category">{survey?.M_CommercialSubCategory?.CommCategorySubName}</Descriptions.Item>
          <Descriptions.Item label="Road Rout Master">{survey?.RoadRout?.RoadRoutDetails}</Descriptions.Item>
          <Descriptions.Item label="Road Rout Plot Master">{survey?.RoadRoutPlot?.RoadRoutDetails}</Descriptions.Item>
          <Descriptions.Item label="Total Covered Area (in sq.ft.)">
            {survey.total_covered_area_plot && Object.entries(survey.total_covered_area_plot).map(
              ([floor, area], index) => (
                <li key={index}><strong>{floor}:</strong> {area}</li>
              )
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Total Sum">{survey.total_sum}</Descriptions.Item>
          <Descriptions.Item label="Open Land Monthly Rent (in Rs.)">{survey.openlandarea_monthlyrent_yearly}</Descriptions.Item>
          <Descriptions.Item label="Annual Valuation (in Rs.)">
            {survey.annual_valuation && Object.entries(survey.annual_valuation).map(
              ([key, value], index) => (
                <li key={index}><strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}</li>
              )
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Latitude">{survey.latitude}</Descriptions.Item>
          <Descriptions.Item label="Longitude">{survey.longitude}</Descriptions.Item>
          <Descriptions.Item label="Current Address">{survey.current_Address}</Descriptions.Item>
          <Descriptions.Item label="Monthly Rental Rate (in Rs.)">{survey.monthly_rental_rate}</Descriptions.Item>
          <Descriptions.Item label="No Of Floors">{survey.noOfFloors}</Descriptions.Item>
          <Descriptions.Item label="No Of Rooms">{survey.noOfRooms}</Descriptions.Item>
          <Descriptions.Item label="Toilet Available">{survey.toiletAvailable}</Descriptions.Item>
          {survey.toiletAvailable?.toLowerCase().trim() === "yes" && (
            <Descriptions.Item label="Toilet Type">{survey.toiletType}</Descriptions.Item>
          )}
          <Descriptions.Item label="Water Connection">{survey.waterConnection}</Descriptions.Item>
          <Descriptions.Item label="Remarks">{survey.remarks}</Descriptions.Item>
          <Descriptions.Item label="Id Type">{survey.idType}</Descriptions.Item>
          <Descriptions.Item label="Id Number">{survey.idNumber}</Descriptions.Item>
          <Descriptions.Item label="Status">{survey.status}</Descriptions.Item>
          <Descriptions.Item label="Survey Approved By">{survey.approvedBy}</Descriptions.Item>
          <Descriptions.Item label="Survey Rejected By">{survey.rejectedBy}</Descriptions.Item>
          <Descriptions.Item label="Survey Rejected Reason">{survey.rejectedReason}</Descriptions.Item>
          <Descriptions.Item label="Created At">{survey.created_at ? dayjs(survey.created_at).format('YYYY-MM-DD HH:mm:ss') : ''}</Descriptions.Item>
          <Descriptions.Item label="Created By">{survey.user?.name}</Descriptions.Item>
          {/* Add more fields as needed */}
        </Descriptions>
      </Card>
    </div>
  );
};

export default SurveyDetails; 